import WindPlot from "../wind";
import WeatherPlot from "../weather";
//import SpotMap from "../spotmap";
import PressurePlot from "../pressure";
import { getStationData } from "../util";
import Box from "@mui/material/Box";


export default function Greifensee ({ forecast }) {

  // Get forecast for this station
  let [vmax, speed, dir, t2m, precip, dursun, twater, qff] = getStationData(forecast, "GRE", "greifensee", "QFF_KLO_GVE");

  return (
    <div>
      <title>Greifensee Windvorhersage - Surfwetter</title>
      <div className="App">
        <div className="Content">
          <h2>Greifensee</h2>
          {/*<SpotMap name="Greifensee" zoom={12} spot={vmax.attrs}/>*/}
          <h3>Schloss Greifensee</h3>
          <Box sx={{ overflow: "auto" }}>
            <WindPlot vmax={vmax} speed={speed} dir={dir} />
            <PressurePlot qff={qff} label="Zürich − Genf" label_plus="Bise" label_minus="Westwind" />
            <WeatherPlot t2m={t2m} precip={precip} sun={dursun} twater={twater} />
          </Box>
        </div>
      </div>
    </div>
  );
};
